import React, { Component } from 'react';
import RadioButton from './RadioButton';
import starBlack from '../assets/img/star_black.png';
import starGold from '../assets/img/star_gold.png';

export default class StarRating extends Component {
  render(){
    const {
      numberOfStars,
      value,
      onSelectedStar
    } = this.props;
    const starsList = [...Array(numberOfStars)].map((_, index) => {
      return (
        <RadioButton
          key={index+1}
          id={`starRating${index+1}`}
          name="star"
          type="radio"
          label={
            <div>
              <div className="star-label-dummy">{index+1}</div>
              <img
              src={(index+1) > value ? starBlack : starGold}
              alt="Rating Star"/>
            </div>
          }
          value={value}
          onChange={onSelectedStar.bind(this, index+1)}
        />
      )
    });
    return <div className="stars-container">{starsList}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/StarRating.js